const initialState = { 
  loading: false,
  page: 1,
  pages: 1,
  payload: [],
  error: null
}

function listProductReducer(state = initialState, action) {
  switch (action.type) {
    case 'LIST_PRODUCT_BEGIN':
      return {
        ...state,
        loading: true,
        payload: [],
        error: null
      }

    case 'LIST_PRODUCT_SUCCESS':
      return {
        ...state,
        loading: false,
        page: action.page,
        pages: action.pages,
        payload: action.payload
      }

    case 'LIST_PRODUCT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default listProductReducer